import { carouselItems } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">焦点专题</h2>
          <p className="text-foreground-600 text-base max-w-xl mx-auto">精选最受关注的吃瓜专题，一次看遍热门事件全貌</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {carouselItems.map((item) => (
            <article key={item.id} className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200/60 transition-colors">
              <div className="relative aspect-[3/2] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 text-xs font-medium bg-primary-500 text-background-50 rounded-full">{item.tag}</span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 line-clamp-2">{item.title}</h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-3">{item.description}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}